module.exports = __webpack_public_path__ + "static/media/bg.5d540a8b.png";